import React, { useEffect } from "react";
import { View, StyleSheet, TouchableOpacity } from "react-native";
import { useSelector, useDispatch } from "react-redux";
import LinearGradient from "react-native-linear-gradient";
import colors from "@constants/color";
import BackArrow from "@assets/svg/BackArrow";
import CustomText from "@components/CustomText";
import { scale, verticalScale } from "@utils/scale";
import { getAllWalletMetaData, getWalletSummary } from "@services/api";
import { actions as walletActions } from "@reducers/oldWalletReducer";

const textMap = {
  ccfp: {
    headerTitle: "सिटीमॉल चिल्ड्रन फ्यूचर प्लान",
    headerSubTitle: "CCFP टोटल फंड",
    contentHeading: "सिटीमॉल चिल्ड्रन फ्यूचर प्लान फंड से पैसे निकालें",
    contentDesc:
      "CCFP फंड को अपने बैंक अकाउंट में ट्रांसफर करने के लिए अपना बैंकअकाउंट जोड़ें",
  },
  default: {
    headerTitle: "आपका गुल्लक",
    headerSubTitle: "आपकी गुल्लक मनी",
    contentHeading: "गुल्लक मनी निकालें",
    contentDesc:
      "गुल्लक मनी को अपने बैंक अकाउंट में ट्रांसफर करने के लिए अपना बैंकअकाउंट जोड़ें",
  },
};

const WithdrawMoneyHeader = ({ navigation, from = "default" }) => {
  // const {
  //   walletSummary: { totals = {} },
  // } = useSelector((state) => state.wallet);
  const dispatch = useDispatch();

  const { walletSummary = {} } = useSelector((state) => state.wallet);
  // const totals = walletSummary?.totals ?? {};
  useEffect(() => {
    if (!walletSummary) {
      // fetch wallet summary
      getAllWalletMetaData()
        .then(({ data }) => {
          const {
            default: { toDate, fromDate },
          } = data.filters;
          // dispatch(walletActions.fetchFundAccounts());
          dispatch(walletActions.setWalletMetaData(data));
          return getWalletSummary({ to: toDate, from: fromDate });
        })
        .then(({ data }) => {
          dispatch(walletActions.setWalletSummary(data));
        })
        .catch((err) => {
          console.log("eror from wallet fetch", err);
        });
    }
  }, []);

  const totals = walletSummary?.totals ?? {};

  const {
    ccfpSummary: { total_fund_balance = 0 },
  } = useSelector((s) => s.ccfp);

  const displayBalance = (f) => {
    if (f === "ccfp") return +total_fund_balance;
    else return totals ? (totals.balance ? totals.balance : 0) : 0;
  };

  return (
    <LinearGradient
      colors={[colors.white, colors.white]}
      start={{ x: 0.0, y: 0.1 }}
      end={{ x: 0.9, y: 0.4 }}
      style={styles.headerContainer}
    >
      <View
        style={[
          styles.beLikeRow,
          { justifyContent: "space-between", marginBottom: 24 },
        ]}
      >
        <View style={[styles.beLikeRow]}>
          <TouchableOpacity
            onPress={navigation.goBack}
            style={{ padding: 10, paddingLeft: 0 }}
          >
            <BackArrow color={colors.black} />
          </TouchableOpacity>
          <CustomText
            style={[
              styles.text,
              { fontSize: scale(18), marginTop: verticalScale(4) },
            ]}
            variant="title_20"
          >
            {textMap[from].headerTitle}
          </CustomText>
        </View>
      </View>
      <View style={styles.beLikeRow}>
        <TouchableOpacity
          style={[
            styles.beLikeRow,
            { marginLeft: "auto", paddingVertical: 5, flex: 1 },
          ]}
        >
          <CustomText style={[styles.text]} variant="body_text_1">
            {textMap[from].headerSubTitle}
          </CustomText>
        </TouchableOpacity>
        <CustomText style={[styles.text]} variant="title_20">
          ₹{displayBalance(from)}
        </CustomText>
      </View>
    </LinearGradient>
  );
};

const styles = StyleSheet.create({
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  headerContainer: {
    padding: 10,
  },
  text: {
    color: colors.black,
  },
});

export default WithdrawMoneyHeader;
